import type { VoidFunctionComponent } from 'react';
import type { SlackProfileResponse } from '../../../../../shared/model-typings';
import { BUTTON_SIZE, FormGroup, LabeledTextInput } from '../../../generic';
import Button from '../../../generic/Button';

type Props = {
  notification: SlackProfileResponse,
  onDisconnect: () => void;
};

const WebhookRow: VoidFunctionComponent<Props> = ({
  notification,
  onDisconnect,
}) =>
  <FormGroup direction="row" spacing="xl" baselineAlignment>
    <LabeledTextInput
      label="Webhook URL"
      value={notification.webhook_url || ''}
      isDisabled
    />
    <LabeledTextInput
      label="Channel"
      value={notification.channel || ''}
      isDisabled
    />
    <Button
      type="error"
      size={BUTTON_SIZE.MEDIUM}
      onClick={onDisconnect}
    >
      Remove
    </Button>
  </FormGroup>;

export default WebhookRow;
